import { WEBSITE_URL } from 'core-lib/data/common';
import { trackCustomGTMEvent } from 'core-lib/utils/events';
import { EventCategoryName } from 'core-lib/types/Events';
import { formatFuelBalance } from 'core-lib/utils/fuel';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { SkuType } from 'src/modules/parkplusStoreV2/types/product';
import { trackCtaClickedStoreV2 } from 'src/modules/parkplusStoreV2/utils/events';
import { Button } from 'ui-v2/components/Button';
import { Typography } from 'ui-v2/components/Typography';
import CartCta from '../../CartCta';
import { AddToCartChildProps } from '../AddToCart';
import s from './ProductDescriptionAOC.module.scss';

export const ProductDescriptionAOC = ({
  isInStock,
  isInCart,
  onNotifyMe,
  onViewCart,
  onAddToCart,
  isLoading,
  loyaltyPoints,
  balance,
  skuType, // fuel balance
  productType,
  title,
  productId,
  section,
}: AddToCartChildProps) => {
  // state
  const [selectedButton, setSelectedButton] = useState<number>();

  const { profile } = useSelector((state: any) => state.auth);

  const { basePath, asPath } = useRouter();
  const pageUrl = `${WEBSITE_URL}${basePath}${asPath}`;

  if (!isInStock) {
    return (
      <div className={s.outOfStock}>
        <Button label="NOTIFY ME" onClick={onNotifyMe} variant="primary" size="large" />
        <Button disabled label="Out of Stock" variant="tertiary" size="large" />
      </div>
    );
  }
  if (isInCart) {
    return <CartCta />;
  }
  //required ml is greater than fuel balance of customer
  if (skuType === SkuType.ExternalVoucher && loyaltyPoints > balance) {
    return (
      <div className={s.lowBalance}>
        <div className={s.wrapper}>
          <Button
            size="large"
            variant="tertiary"
            label={`Claim for ${formatFuelBalance(loyaltyPoints)}`}
            disabled
            fullWidth
          />
        </div>
        <div className={s.alertText}>
          <Typography
            label={`${formatFuelBalance(loyaltyPoints - balance)} more required`}
            color="negative"
            variant="label_4_medium"
          />
        </div>
      </div>
    );
  }
  return (
    <div className={s.root}>
      <div className={s.item}>
        <Button
          size="large"
          label="Buy Now"
          onClick={e => {
            setSelectedButton(1);
            onAddToCart(e, 1, null, true);
            onViewCart(e);
            trackCtaClickedStoreV2(productType, 'buy_now', {
              product_id: productId,
              section: section,
            });
            trackCustomGTMEvent({
              eventName: 'pm_35_buy_now',
              attributes: {
                category: EventCategoryName.Store,
                sku_id: productId,
                page_url: pageUrl,
              },
            });
          }}
          fullWidth
          variant="secondary_grey"
          loading={isLoading && selectedButton === 1}
          disabled={isLoading && selectedButton === 2}
        />
      </div>
      <div className={s.item}>
        <Button
          label="Add to cart"
          variant="primary"
          size="large"
          onClick={e => {
            setSelectedButton(2);
            onAddToCart(e);
            trackCtaClickedStoreV2(productType, 'add_to_cart', {
              product_id: productId,
              section: section,
            });
            trackCustomGTMEvent({
              eventName: 'pm_35_add_to_cart',
              attributes: {
                category: EventCategoryName.Store,
                sku_id: productId,
                page_url: pageUrl,
              },
            });
          }}
          fullWidth
          loading={isLoading && selectedButton === 2}
          disabled={isLoading && selectedButton === 1}
        />
      </div>
    </div>
  );
};
